package com.wintermar.inspection.feature.presentation.inspection.answer.widget.finding_category

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.feature.util.finding_category.FindingCategoryView
import com.wintermar.inspection.graphql.type.FindingCategory
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_check
import inspection.composeapp.generated.resources.icon_content_description
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun FindingCategoryContent(
    selectedFindingCategory: FindingCategory?,
    referenceItems: List<SelectionModel>,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color,
    onSelectedFindingCategory: (FindingCategory) -> Unit
) {
    val scope = rememberCoroutineScope()
    var selectedItem by remember(selectedFindingCategory) {
        mutableStateOf(selectedFindingCategory)
    }

    LazyColumn {
        items(referenceItems) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable {
                        selectedItem = FindingCategory.safeValueOf(it.id)
                        selectedItem?.let { selected ->
                            scope.launch {
                                delay(300)
                                onSelectedFindingCategory(selected)
                            }
                        }
                    }
                    .padding(
                        vertical = dimension.spacing.space4,
                        horizontal = dimension.spacing.space5
                    ),
                horizontalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space3,
                ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(
                    modifier = Modifier.weight(0.9f)
                ) {
                    FindingCategoryView(
                        category = FindingCategory.safeValueOf(it.id),
                    )
                }

                Row(
                    modifier = Modifier.weight(0.1f)
                ) {
                    if (selectedItem == FindingCategory.safeValueOf(it.id)) {
                        Icon(
                            painter = painterResource(Res.drawable.ic_check),
                            tint = color.icon.brand,
                            modifier = Modifier.size(dimension.size.icon.s),
                            contentDescription = stringResource(Res.string.icon_content_description),
                        )
                    }
                }
            }
            HorizontalDivider(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = dimension.spacing.space5),
                color = color.border.subtle
            )
        }
    }
}
